import React from 'react';
import { Outlet } from 'react-router-dom';
import ShipturtleHeader from '../components/ShipturtleHeader';
import TerminalErrorBoundary from '../components/feedback/TerminalErrorBoundary';
import styles from './SuspireTerminalLayout.module.css';

/**
 * Single shell for all /suspire-terminal/* routes so the top terminal navbar
 * mounts once and stays consistent (width/alignment) across index and sections.
 */
function SuspireTerminalLayout() {
  return (
    <div className={styles.page}>
      <div className={styles.headerShell}>
        <ShipturtleHeader />
      </div>
      <div className={styles.outletShell}>
        {/*
          The boundary wraps the outlet only, deliberately: if a section throws
          while rendering, the header and its tabs stay mounted so the user can
          click through to another section instead of facing a blank page.
        */}
        <TerminalErrorBoundary>
          <Outlet />
        </TerminalErrorBoundary>
      </div>
    </div>
  );
}

export default SuspireTerminalLayout;
